<template>
    <div>
        <common-page-plain padding="tiny">
            <div class="home">
                <div class="home__left">
                    <common-content-spacer height="medium">
                        <div class="home--header">
                            <img class="home--header__image" :alt="$t('alt.company_avatar')" :src="homeCover" />
                            <div class="home--header__text">
                                <p>{{ $t('pages.home.home.cover.text') }}</p>
                                <common-button
                                    class="home--header__button"
                                    type="quaternary"
                                    :label="$t('pages.home.home.cover.button')"
                                    @click="openFindOfferPage()"
                                ></common-button>
                            </div>
                        </div>

                        <div v-show="!isLoading" class="home--offers">
                            <common-filter-preview @filter-changed="filterChanged"></common-filter-preview>
                            <common-content-spacer height="medium">
                                <common-grid-items v-if="offers?.length">
                                    <offer-card-component
                                        v-for="offer in offers"
                                        :key="offer.id"
                                        :offer="offer"
                                        @location-click="locationClicked"
                                    ></offer-card-component>
                                </common-grid-items>
                                <div v-else>{{ $t('pages.home.home.cover.no_offers') }}</div>
                            </common-content-spacer>
                        </div>

                        <common-buttons align="center">
                            <common-button
                                v-if="offers.length"
                                type="primary"
                                :label="$t('pages.home.home.cover.show_all')"
                                :isProcessing="isLoading"
                                @click="openFindOfferPage()"
                            ></common-button>
                        </common-buttons>
                    </common-content-spacer>
                </div>
                <div class="home__right">
                    <common-top-companies :isProessing="isLoading"></common-top-companies>
                    <div class="home--clock">
                        <img class="home--clock__image" :alt="$t('alt.clock')" :src="clockCover" />
                        <div class="home--clock__date">
                            <p class="home--clock__date--day">{{ new Date().getDate() }}</p>
                            <p class="home--clock__date--month">{{ getCurrentMonth }}</p>
                            <p class="home--clock__date--text">{{ $t('pages.home.home.widget.book_experience') }}</p>
                        </div>
                        <common-time-widget></common-time-widget>

                        <common-buttons align="center">
                            <common-button
                                class="home--clock__button"
                                type="primary"
                                :label="$t('pages.home.home.widget.find_offers')"
                                @click="openFindOfferPage()"
                            ></common-button>
                        </common-buttons>
                    </div>
                </div>
            </div>
        </common-page-plain>
    </div>
</template>

<script>
    import RoutesEnum from 'enums/routes.enum'
    import OfferAPI from 'api/OfferAPI'
    import OfferCardComponent from 'components/page-elements/offer/OfferCardComponent'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    import Store from '~/store'

    export default {
        mixins: [WindowResizeMixin],
        components: { OfferCardComponent },

        data() {
            return {
                homeCover: require('../../assets/images/home-heaer.png'),
                clockCover: require('../../assets/images/clock-image.png'),
                isHovered: false,
                RoutesEnum: RoutesEnum,
                isLoading: false,
                limit: 0,
                offset: 0,
                orderBy: 'random',
                filters: [],
                serviceGroupId: undefined,
                offers: [],
                month: new Date().getMonth(),
            }
        },

        computed: {
            getCurrentMonth() {
                return this.$t(`common.months.${this.month}.long`)
            },

            countryByGeolocation() {
                return Store.getters['data/getCountryByGeolocation']
            },
        },

        methods: {
            locationClicked(location) {
                window.open(`https://www.google.com/maps/place/${location.lat},${location.lng}`, '_blank')
            },
            getOffers(filter) {
                this.isLoading = true
                Store.dispatch('configuration/setIsLoading', true)
                OfferAPI.findOffers(filter).then((res) => {
                    this.offers = res.page
                    this.totalCount = res.total
                    this.isLoading = false
                    Store.dispatch('configuration/setIsLoading', false)
                })
            },

            filterChanged(event) {
                const filter = {
                    take: this.limit,
                    skip: this.offset,
                    orderBy: this.orderBy,
                }
                if (Store?.getters['data/getCountryByGeolocation']) {
                    filter.countryId = Store?.getters['data/getCountryByGeolocation']
                }
                this.serviceGroupId = event.serviceGroupId
                if (event.serviceGroupId) {
                    filter.serviceGroupId = event.serviceGroupId
                }
                this.getOffers(filter)
            },

            openFindOfferPage() {
                let query = {}
                if (Number(this.serviceGroupId)) {
                    query.serviceGroupId = this.serviceGroupId
                }

                if (Store?.getters['data/getCountryByGeolocation']) {
                    query.countryId = Store?.getters['data/getCountryByGeolocation']
                }

                this.$router.push({
                    name: RoutesEnum.OFFER.FIND,
                    query: query,
                })
            },

            getLimit() {
                switch (true) {
                    case (this.windowWidth >= 812 && this.windowWidth <= 1024) ||
                        (this.windowWidth >= 1252 && this.windowWidth <= 1501):
                        return 9
                    case (this.windowWidth >= 1502 && this.windowWidth <= 1751) ||
                        (this.windowWidth >= 2002 && this.windowWidth <= 2251):
                        return 12
                    case this.windowWidth >= 1752 && this.windowWidth <= 2001:
                        return 15
                    case this.windowWidth >= 2252 && this.windowWidth <= 2501:
                        return 14
                    case this.windowWidth >= 2502 && this.windowWidth <= 2751:
                        return 16
                    case this.windowWidth >= 2752 && this.windowWidth <= 3001:
                        return 18
                    case this.windowWidth >= 3002 && this.windowWidth <= 3251:
                        return 20
                    case this.windowWidth >= 3251 && this.windowWidth <= 3501:
                        return 22
                    case this.windowWidth >= 3502 && this.windowWidth <= 3501:
                        return 24
                    default:
                        return 10
                }
            },

            setLimit(num) {
                this.limit = num
            },
        },

        watch: {
            countryByGeolocation() {
                const filter = {
                    take: this.limit,
                    skip: this.offset,
                    orderBy: this.orderBy,
                }
                if (this.countryByGeolocation) {
                    filter.countryId = this.countryByGeolocation
                }
                this.getOffers(filter)
            },
        },

        mounted() {
            if (this.$route.query.wrong_subdomain) {
                this.$toast.error(this.$t('common.errors.wrong_subdomain'))
            }
            if (this.$route.query.verify) {
                this.$toast.success(this.$t('pages.auth.login.messages.success'))
            }
            const newLimit = this.getLimit()
            this.setLimit(newLimit)
            const filter = {
                take: this.limit,
                skip: this.offset,
                orderBy: this.orderBy,
            }
            if (Store?.getters['data/getCountryByGeolocation']) {
                filter.countryId = Store?.getters['data/getCountryByGeolocation']
            }
            this.getOffers(filter)
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .page-plain {
        @include breakpoint(tablet) {
            padding: 5px;
        }
    }

    .home {
        display: flex;
        flex-wrap: wrap;
        &__left {
            @include breakpoint(tablet) {
                width: 100%;
                padding-right: 0;
                .loader {
                    top: 100%;
                }
            }
            width: calc(100% - 350px);
            padding-right: 20px;
            position: relative;
        }
        &__right {
            @include breakpoint(tablet) {
                width: 100%;
                padding-left: 0;
                margin-top: 50px;
            }
            width: 350px;
            padding-left: 20px;

            .top-companies {
                margin-bottom: 30px;
            }
        }
        &--header {
            margin-bottom: 32px;
            position: relative;
            overflow-x: hidden;

            &__image {
                object-fit: cover;
                height: 100%;
                width: 100%;
                min-height: 306px;
            }

            &__button {
                @include breakpoint(smartphone-large) {
                    left: 150px;
                    top: -50px;
                    left: 135px;
                }

                @include breakpoint(smartphone) {
                    position: absolute !important;
                    top: 120px;
                    left: -20px;
                    transform: translateX(50%);
                }

                position: absolute;
                left: 200px;
                top: -70px;
            }

            &__text {
                @include breakpoint(smartphone-large) {
                    font-size: 33px;
                    line-height: 50px;
                    max-width: 300px;
                    left: 10px;
                }

                @include breakpoint(smartphone) {
                    left: 50%;
                    transform: translateX(-50%);
                    text-align: center;
                }

                position: absolute;
                width: 415px;
                height: 61px;
                left: 58px;
                top: 90px;
                font-family: 'Poppins';
                font-style: normal;
                font-weight: 600;
                font-size: 45px;
                line-height: 60px;
                letter-spacing: -0.02em;
                color: $color-white;
            }
        }

        &--clock {
            background: #e49c63;
            border-radius: 20px;
            padding: 20px;
            position: relative;
            overflow: hidden;

            &__button {
                z-index: 1;
            }

            &__image {
                position: absolute;
                z-index: 0;
            }

            &__date {
                text-align: center;
                color: #facdbb;

                &--day {
                    font-size: 60px;
                    line-height: 60px;
                    font-weight: 700;
                }

                &--month {
                    font-size: 30px;
                    line-height: 30px;
                    font-weight: 700;
                }

                &--text {
                    font-size: 24px;
                    margin-top: 30px;
                    font-weight: 700;
                }
            }
        }
    }
</style>
